import React from 'react';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faBolt, faLayerGroup, faChartLine, faWallet, faRocket, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import logo from '../logo.png';
import './Index.css';

interface IndexProps { }

export function Index(props: IndexProps) {
    const navigate = useNavigate();

    const features = [
        {
            icon: faChartPie,
            title: 'Depth Yield Analysis',
            desc: 'Calculate precise liquidity mining yields and compare market-making returns vs HODL strategies.'
        },
        {
            icon: faBolt,
            title: 'Real-time Data',
            desc: 'Minute-level updates for APY and TVL to capture the latest market dynamics instantly.'
        },
        {
            icon: faLayerGroup,
            title: 'Smart Pool Selection',
            desc: 'Discover high-potential pools using multi-dimensional metrics including weekly/daily yields.'
        },
        {
            icon: faChartLine,
            title: 'Historical Performance',
            desc: 'Track pool profit trends and your operation history to optimize future investment strategies.'
        },
        {
            icon: faWallet,
            title: 'Asset Dashboard',
            desc: 'Visual overview of your wallet assets, capital deployment, and real-time earnings.'
        },
        {
            icon: faRocket,
            title: 'Instant Add Liquidity',
            desc: 'Add liquidity in a single click with parameters perfectly synced to analyzed yields.'
        }
    ];

    return (
        <main className="landing-page">
            <div className="landing-background">
                <div className="orb orb-1"></div>
                <div className="orb orb-2"></div>
                <div className="grid-overlay"></div>
            </div>

            <header className="hero">
                <div className="hero-content">
                    <div className="hero-badge">
                        <span className="badge-dot"></span>
                        Live on Mainnet, Binance Smart Chain, Base
                    </div>
                    <h1>
                        <span className="text-gradient">Maximize Your</span> <br />
                        <span className="text-gradient">DeFi Yields</span>
                    </h1>
                    <p className="slogan">
                        Precision data analytics and real-time insights for professional liquidity providers.
                    </p>
                    <div className="hero-actions">
                        <button className="cta-button primary" onClick={() => navigate('/list')}>
                            Launch App <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                        {/* <button className="cta-button secondary" onClick={() => window.open('https://docs.uniswap.org/', '_blank')}>
                            Documentation
                        </button> */}
                    </div>
                </div>
                <div className="hero-visual">
                    <div className="logo-container">
                        <img src={logo} className="app-logo" alt="LiquidMap Logo" />
                        <div className="logo-glow"></div>
                    </div>
                </div>
            </header>

            <section className="feature-grid">
                {features.map((feature, index) => (
                    <article key={index} className="feature-card">
                        <div className="feature-icon-wrapper">
                            <FontAwesomeIcon icon={feature.icon} className="feature-icon" />
                        </div>
                        <h3 className="feature-title">{feature.title}</h3>
                        <p className="feature-desc">{feature.desc}</p>
                    </article>
                ))}
            </section>
        </main>
    );
}

export default Index;
